import { render } from "./SessionsList.vue?vue&type=template&id=5cb57a4e&scoped=true"
import script from "./SessionsList.vue?vue&type=script&lang=js"
export * from "./SessionsList.vue?vue&type=script&lang=js"

import "./SessionsList.vue?vue&type=style&index=0&id=5cb57a4e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cb57a4e"]])

export default __exports__